import type { SystemStyleObject } from '@chakra-ui/react'

/**
 * Keyboard focus ring for buttons and other controls: a 2px `brand.fg`
 * outline offset 2px outside the control, so it is measured against the page
 * background and fill or shadow changes on hover, press, or expanded can't
 * hide it. `brand.fg` keeps 3:1 on light and dark page backgrounds in every
 * partner theme; `brand.focusRing`, `brand.muted`, and `shadows.focusRing`
 * do not.
 */
export const keyboardFocusRing = {
  focusVisibleRing: 'outside',
  focusRingColor: 'brand.fg',
} as const satisfies SystemStyleObject

/**
 * `keyboardFocusRing` as plain outline properties, for selectors that are
 * already scoped to `:focus-visible` (global styles).
 */
export const keyboardFocusOutline = {
  outlineWidth: '2px',
  outlineStyle: 'solid',
  outlineColor: 'brand.fg',
  outlineOffset: '2px',
} as const satisfies SystemStyleObject

/**
 * Keyboard focus ring for text fields and selects: Chakra's inside ring
 * (outline and border), widened to 2px and recolored to `brand.fg`. Set
 * under `:focus-visible` so it outranks the `colorPalette.focusRing` value
 * that Chakra's field variants write on the element itself.
 */
export const formControlFocusRing = {
  _focusVisible: {
    '--focus-color': 'colors.brand.fg',
    '--focus-ring-color': 'colors.brand.fg',
    '--focus-ring-width': '2px',
  },
  _invalid: {
    _focusVisible: {
      '--focus-color': 'var(--error-color)',
      '--focus-ring-color': 'var(--error-color)',
    },
  },
} as const satisfies SystemStyleObject
